var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPortfolioOutlined = function SvgPortfolioOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "#013d8c",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9v1.528c-.476.69-3.815 1.971-9.77 1.971-6.239 0-9.736-1.358-10.23-2.088V9zm2-2H0v3.491C0 13.148 6.154 14.5 12.23 14.5c5.922 0 11.77-1.284 11.77-3.895zm-2 8.074V20H2v-5.001a9.3 9.3 0 0 1-2-1.096V22h24v-7.949a9.5 9.5 0 0 1-2 1.023m-8 1.958C14 18.119 13.104 19 12 19s-2-.881-2-1.968V16h4zM9 2a2 2 0 0 0-2 2v2h2V4.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V6h2V4a2 2 0 0 0-2-2z"
  })));
};
export default SvgPortfolioOutlined;